export const SET_LOCATION = 'SET_LOCATION';
export const SET_STYLE = 'SET_STYLE';
export const SET_TEXT = 'SET_TEXT';
export const SET_SIZE = 'SET_SIZE';  
export const SET_ORDER = 'SET_ORDER';
export const SET_IS_LOADING = 'SET_IS_LOADING' 